import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { events } from "@/mocks/gossip";

const recent = events
  .map((e) => {
    const last = e.timeline[e.timeline.length - 1];
    return { id: e.id, title: e.title, category: e.category, date: e.date, node: last };
  })
  .sort((a, b) => (a.date < b.date ? 1 : -1))
  .slice(0, 5);

export default function TimelineSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="节点更新"
              title="这些事件刚刚有了新进展"
              desc="每当有可核实的新节点出现，我们会把它补进对应事件的时间线，并在这里同步显示最近一次更新。"
            />
            <Link
              to="/events"
              className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 font-label text-sm text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部节点记录
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-6 md:pl-8 space-y-7">
              {recent.map((r, idx) => (
                <li key={r.id} className="relative">
                  <span
                    className={`absolute -left-[31px] md:-left-[39px] top-1.5 w-3 h-3 rounded-full border-2 ${
                      idx === 0
                        ? "bg-primary-500 border-primary-300"
                        : "bg-background-50 border-background-400"
                    }`}
                    aria-hidden="true"
                  ></span>
                  <div className="flex flex-wrap items-center gap-3">
                    <time className="font-heading font-bold text-sm text-primary-700">{r.date}</time>
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-800">
                      {r.category}
                    </span>
                  </div>
                  <Link
                    to={`/event/${r.id}`}
                    className="mt-1.5 block font-heading font-semibold text-base md:text-lg text-foreground-950 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {r.title}
                  </Link>
                  <p className="mt-1 font-label text-sm text-foreground-600">
                    <span className="text-foreground-900 font-medium">{r.node.title}</span>
                    <span className="mx-1.5 text-foreground-300">·</span>
                    {r.node.detail}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}